import { PoliciesPermissionSetItems, PermissionLevels } from 'common/constants/permissions';
import { permissionsArray } from 'modules/permissions/constants';
import { IPermissionItem, IPolicyFormData } from 'modules/permissions/interfaces/permissions';

export const filterPermissionSet = (data: IPolicyFormData): IPolicyFormData => {
  const { permissionSet } = data;
  const permissionValues = Object.values(PoliciesPermissionSetItems) as string[];

  const filteredPermissionSet = permissionSet.filter(permission => {
    return permissionValues.includes(permission);
  });

  return {
    ...data,
    permissionSet: filteredPermissionSet,
  };
};

export const getPermissionsFilteredArray = (
  permissionLevel: PermissionLevels,
  filter?: boolean,
  permissionGroups?: string[],
): Array<IPermissionItem> => {
  const permissions = permissionsArray[permissionLevel];

  if (!permissions) {
    return [];
  }

  return filter && permissionGroups
    ? Object.values(permissions)
        .flat()
        .filter((item: IPermissionItem) => permissionGroups.includes(item.key))
    : Object.values(permissions).flat();
};
